export default __webpack_public_path__ + "static/media/notfound.f16ca75e.jpeg";